import * as React from 'react';
import { flow, forEach, map, size, get } from 'lodash';
import { IBrandingState, II18nMessages } from '../../../../services/branding/models';
import { IProduct, IPremium, IQuotes, IChannel } from '../../../../data/api/models';
import { connect } from 'react-redux';
import { Col, Form, Row } from 'react-bootstrap';
import { IStore } from '../../../../redux/IStore';
import { ICompleteData } from '../../../../services/quote/models';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import FaFileTextO from 'react-icons/fa/file-text-o';
import Loading from '../../../../components/Loading';
import { tagManagerEvent } from '../../../../util/tagManagerEvent';

interface ICompleteProps extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  renderDefinition(name: string): any;
  data: ICompleteData;
  quote: any;
  quotes: IQuotes;
  branding: IBrandingState;
  premium: IPremium;
  channel: IChannel;
}

class IComplete extends React.Component<ICompleteProps> {
  public state = {
    polling: false,
    pollId: null,
    hasSubmittedGTM: false,
  };

  public componentWillMount() {
    const { data } = this.props;

    if (size(data.documents.documents) > 0) {
      return;
    }

    if (this.state.polling) {
      return;
    }

    this.setState({
      polling: true,
    });

    setTimeout(this.pollDocuments, 2000);
  }

  public componentWillUnmount() {
    this.props.reset();
  }

  public componentDidMount() {
    const { data, channel, quote } = this.props;

    if (!this.state.hasSubmittedGTM) {
      tagManagerEvent({
        event: 'purchase',
        customerName: get(quote, `customer[0].customerName`, ''),
        customerEmail: get(quote, `customer[0].email`, ''),
        policyNumber: data.policy_number,
      }, channel);
      this.setState({
        hasSubmittedGTM: true,
      });
    }
  }

  private renderDocument = (url, name) => {
    return (
      <Col sm={6} key={name}>
        <div className="documents">
          <a href={url} target="_blank">
            <FaFileTextO/>
            <span>
              {name}
            </span>
          </a>
        </div>
      </Col>
    );
  }

  private renderCompleteMessage = () => {
    const { channel } = this.props;

    if (['247-b2c', 'ven-b2c'].includes(channel.key)) {
      return (
        <div>
          <div>
            <div className="section-title">
              <p>
                You will also receive an email shortly with details on how to
                access your account and documents to download or keep safe.
                Please be aware that this may have gone into your junk or spam folder.
              </p>
            </div>
          </div>
        </div>
      );
    }

    if (channel.key !== 'fst-b2c') {
      return (
        <div>
          <div>
            <div className="section-title">
              <p>
                YOU WILL ALSO RECEIVE AN EMAIL SHORTLY WITH DETAILS ON HOW TO ACCESS YOUR ACCOUNT AND DOCUMENTS TO
                DOWNLOAD OR KEEP SAFE. PLEASE BE AWARE THAT THIS MAY HAVE GONE INTO YOUR JUNK OR SPAM FOLDER.
              </p>
            </div>
          </div>
        </div>
      );
    }
  }

  private renderTrackingItems = () => {
    const { branding, premium, data, channel } = this.props;

    const items = [];

    if (branding.aggregatorTracking.type === 'cyti') {
      const params = branding.aggregatorTracking.cyti;
      const cytiUrl = branding.aggregatorTracking.cyti.url + '/track/confirm';

      items.push(
        <img
          key={0}
          // tslint:disable-next-line:max-line-length
          src={`${cytiUrl}?cref=${params.cref}&policyreference=${data.policy_number}&premium=${premium.gross}&t=${params.token}`}
          height="0"
          width="0"
        />,
      );
    }

    if (branding.aggregatorTracking.type === 'idol') {
      const params = branding.aggregatorTracking.idol;
      // const url = 'https://www.quote-link.net/travel/salestracking/travelquotes_sale_confirmation.cfm';
      const url = 'https://quotes.theidol.com/v1/travel/pixels/provisionalSales/freespirit';

      items.push(
        <img
          key={0}
          src={`${url}?ref=${params.reference}&fullprem=${premium.gross}`}
          height="0"
          width="0"
        />,
      );
    }

    return items;
  }

  private pollDocuments = () => {
    const { data, actions } = this.props;

    actions.quote.pollPolicyDocuments(data.documents_poll_token).then(({ documents }) => {
      if (documents.length === 0) {
        this.setState({
          pollId: window.setTimeout(this.pollDocuments, 2000),
        });

        return;
      }

      actions.quote.completeDocuments({ documents });

      this.setState({
        polling: false,
        pollId: null,
      });
    });
  }

  public render() {
    const { data, channel } = this.props;

    let thankYou = 'Thank you for purchasing ' + channel.baseName;
    if (!thankYou.endsWith('Insurance')) {
      thankYou += ' insurance';
    }
    let documentText = 'We recommend that you read these documents carefully to ensure the details\n' +
      'are correct and the cover provided meets your needs. The Insurance Policy\n' +
      'contains the full policy terms, conditions and exclusions of your cover\n' +
      'as well as details of what to do in the event of a medical emergency.';

    if (['247-b2c', 'ven-b2c'].includes(channel.key)) {
      documentText = 'We recommend that you read these documents carefully to ensure the details\n' +
        'are correct and the cover provided meets your needs. The Insurance Policy\n' +
        'contains the full policy terms, conditions and exclusions of your cover,\n' +
        'complaint procedure and details of what to do in the event of a medical emergency.';
    }
    if (['fst-b2c'].includes(channel.key)) {
      documentText = 'Please read these documents carefully to ensure the details are correct and the cover provided ' +
        'meets your needs. The Insurance Policy contains the full policy terms, conditions and exclusions of your ' +
        'cover, complaint procedure and details of what to do if you need medical assistance on your trip.\n' +
        '\n\n' +
        'You might wish to print out your policy schedule and take it with you. If you have an account with us, you ' +
        'can access these documents 24/7 via your personalised account.';
    }

    return (
      <Form>
        <div className="steps-container">
          <div className="section-title">
            {['fst-b2c'].includes(channel.key) ? (
              <h1>That’s it, you’re covered!</h1>
            ) : (
              <h1>You're covered</h1>
            )}
          </div>

          <div className="section">
            <Row>
              <h3><strong>{thankYou}</strong></h3>
              <p className="margin-top">
                Your policy number is <span className="policy-number">{data.policy_number}</span>
              </p>

              <p>
                Please find below links to your policy documents.
              </p>

              <div>
                {this.state.polling ? (
                  <div className="policy-documents">
                    <Loading/>
                  </div>
                ) : (
                  <Row className="policy-documents">
                    {map(data.documents, this.renderDocument)}
                  </Row>
                )}
              </div>
              <p>
                {documentText}
              </p>
              {channel.key === 'lsb-b2c' && (
                <div>
                  <p>
                    You have a 14 day cooling off period. Please check that the cover meets your
                    requirements. If not, contact us within the 14 days to arrange a refund of premium.
                    Cancellations requests received outside the cooling off period will be subject to the
                    terms as shown in the cancellation rights detailed within your insurance policy.
                  </p>
                  <p>
                    If your health or your on-going medication changes between the date the policy was bought
                    and the date of travel you must advise P J Hayman & Company Ltd as soon as possible on
                    02392 419 068. We will advise you what cover we are able to provide for your change in
                    health, as defined in your insurance policy, after the date of diagnosis.
                  </p>
                  <p>
                    If you receive any medical attention whilst overseas and the medical bills are likely to
                    be more than £500 please contact the Assistance Service.
                  </p>
                </div>
              )}
              <div className="clearfix" />
            </Row>
          </div>
          {this.renderCompleteMessage()}
          {this.renderTrackingItems()}
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const { quotes, complete } = state.quote;

      let premium: IPremium = null;

      const values = selector(
        state,
        'tripType',
        'schemeId',
        'quoteReference',
        'steps',
      );

      if (state.quote.quotes) {
        forEach(state.quote.quotes, (tripTypes, level) => {
          forEach(tripTypes, (quotedPremium: IPremium) => {
            if (!quotedPremium) {
              return null;
            }

            if (quotedPremium.scheme.id === values.schemeId) {
              premium = quotedPremium;
            }
          });
        });
      }

      return {
        data: complete,
        quotes,
        branding: state.branding,
        premium,
      };
    },
  ),
])(IComplete);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Complete/index.tsx